<template>
  <div class="LKMunMehFormDocuments">
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      :size="50"
      style="width: 100%; margin: 16px;"
    />

    <template v-else>
      <v-expand-transition>
        <div v-show="!isNoDocAttaching">
          <div
            v-for="(doc, idx) in docs"
            :key="idx"
            class="LKMunMehFormDocuments__content"
          >
            <div
              v-if="doc.isNewDocument || doc.isChangedDocument"
              class="LKMunMehFormDocuments__content__changes"
              v-text="'Изменения не сохранены'"
            />
            <BTextField
              :value="doc.link"
              :validate="!isNoDocAttaching ? {required: true, url: { require_protocol: true }, max: 2000} : {}"
              label="Ссылка"
              :readonly="disabled"
              style="margin-bottom: 16px;"
              @input="link => setDocLink({ doc, link })"
            />

            <BTextarea
              :value="doc.comment"
              label="Комментарий к документу"
              :rows="1"
              :readonly="disabled"
              style="margin-bottom: 16px;"
              @input="comment => setDocComment({ doc, comment })"
            />

            <LKMunMehFormFooter
              v-if="idx !== docs.length - 1"
              :docs="docs"
              only-deletion
              :disabled="disabled"
              :selected-for-delete="isDeletable(doc, idx)"
              @delete="deleteDocument(doc, idx)"
            />
          </div>
        </div>
      </v-expand-transition>

      <LKMunMehFormFooter
        v-model="isNoDocAttaching"
        class="LKMunMehFormDocuments__footer"
        :docs="docs"
        :disabled="disabled"
        :selected-for-delete="isDeletable(docs[docs.length - 1], docs.length - 1)"
        @append:document="onCreateDocument"
        @delete="deleteDocument(docs[docs.length - 1], docs.length - 1)"
      />
    </template>
  </div>
</template>

<script>
import BTextarea from '@/components/forms/BTextarea.vue'
import BTextField from '@/components/forms/BTextField.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKMunMehFormFooter from '@/views/LKMunMeh/Form/components/LKMunMehFormDocumentsFooter.vue'

import { lkMunMehFormMapper } from '@/views/LKMunMeh/Form/store'

export default {
  name: 'LKMunMehFormDocuments',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BTextarea,
    BTextField,
    LKProgressCircular,
    LKMunMehFormFooter,
  },
  props: {
    thirdLevelId: {
      type: Number,
      required: true,
    },
    fourthLevelId: {
      type: Number,
      required: true,
    },
    munMehId: {
      type: Number,
      required: true,
    },
    disabled: Boolean,
  },
  computed: {
    ...lkMunMehFormMapper.mapState(['documents', 'deleteCheckedDocuments', 'isLoading']),
    deleteDisabled() {
      return this.docs.length === 1 && (!this.docs[0].link && !this.docs[0].comment)
    },

    docContainer() {
      return this.documents.find(({ indicator_id }) => indicator_id === this.fourthLevelId)
    },
    docs() {
      return this.docContainer?.data || []
    },
    isNoDocAttaching: {
      get() {
        return !!this.docContainer?.is_no_documents
      },
      set() {
        this.toggleNoDocs(this.docContainer)
      },
    },
    isLoadingAsyncData() {
      return this.isLoading
    },
  },
  methods: {
    ...lkMunMehFormMapper.mapMutations(['addDocument', 'toggleDelete', 'deleteImmediate', 'setNoDocuments', 'toggleNoDocs', 'setDocLink', 'setDocComment']),
    isDeletable(doc, idx) {
      if (!doc) return false
      if (doc.isNewDocument) {
        return false
      }
      const { fourthLevelId, deleteCheckedDocuments } = this
      return deleteCheckedDocuments.has(fourthLevelId) && deleteCheckedDocuments.get(fourthLevelId)?.includes(idx)
    },
    deleteDocument(doc, idx) {
      const { fourthLevelId } = this
      if (doc.isNewDocument) {
        this.deleteImmediate({ id: fourthLevelId, document: doc })
      } else {
        this.toggleDelete({ id: fourthLevelId, docIdx: idx })
        this.$forceUpdate()
      }
    },
    async onCreateDocument() {
      const emptyIdx = this.docs.findIndex(({ link, comment }) => !link && !comment)
      const result = await this.$validator.validate() && emptyIdx < 0
      if (!result) {
        if (emptyIdx >= 0) {
          this.$notice.warning('В форме есть незаполненный документ')
        } else {
          this.$notice.warning('Ошибки валидации в форме')
        }
        return
      }
      this.addDocument(this.fourthLevelId)
    },
    async validate() {
      const result = await this.$validator.validate()
      return result
    },
  },
}
</script>

<style lang="scss">
.LKMunMehFormDocuments {
  &__content {
    padding: 16px 0 0 0;
    margin-top: 16px;
    background-color: $webflow-color-white;

    &__changes {
      font-size: 12px;
      color: $webflow-color-blue-dark;
    }
  }

  &__footer {
    margin: 16px 0;
  }
}
</style>
